import { render } from "./PartsService.vue?vue&type=template&id=93953090&scoped=true"
import script from "./PartsService.vue?vue&type=script&lang=js"
export * from "./PartsService.vue?vue&type=script&lang=js"

import "./PartsService.vue?vue&type=style&index=0&id=93953090&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93953090"]])

export default __exports__